'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackMenuItemClick = exports.trackLinkClick = exports.trackButtonClick = exports.trackInteractionEvent = exports.ANALYTICS_TIMING = exports.ANALYTICS_INTERACTION_EVENT = undefined;

var _analytics = require('../../constants/analytics');

var ANALYTICS_INTERACTION_EVENT = exports.ANALYTICS_INTERACTION_EVENT = 'ANALYTICS/INTERACTION_EVENT';
var ANALYTICS_TIMING = exports.ANALYTICS_TIMING = 'ANALYTICS/TIMING';

/**
 * An action creator to trigger an analytics interaction event
 *
 * @param {Object} params an object of params for the analytics event
 * @param {String} [params.action='click'] Action which occurred (e.g. 'click')
 * @param {String} params.areaName area of app that event occurred
 * @param {Object} [params.dimensions={}] Optional map of dimensions for this
 *  event (e.g. 'rptKey' or 'rpeKey')
 * @param {Array} params.elementPath Array of strings representing path to the element in which
 *  event occurred
 * @param {String} [params.elementType='button'] Type of element (e.g. 'button' or 'link')
 * @returns {Object} redux action
 */
var trackInteractionEvent = exports.trackInteractionEvent = function trackInteractionEvent(_ref) {
  var _ref$action = _ref.action,
      action = _ref$action === undefined ? _analytics.actionList.click : _ref$action,
      areaName = _ref.areaName,
      elementPath = _ref.elementPath,
      _ref$elementType = _ref.elementType,
      elementType = _ref$elementType === undefined ? _analytics.elementList.button : _ref$elementType,
      _ref$dimensions = _ref.dimensions,
      dimensions = _ref$dimensions === undefined ? {} : _ref$dimensions;
  return {
    type: ANALYTICS_INTERACTION_EVENT,
    payload: {
      elementType: elementType,
      action: action,
      areaName: areaName,
      elementPath: elementPath,
      dimensions: dimensions
    }
  };
};

/**
 * Convenience function for triggering button click interaction events
 *
 * @param {Object} params an object of params for the analytics event
 * @param {String} params.areaName area of app that event occurred
 * @param {Array} params.elementPath Array of strings representing path to the element
 *  in which event occurred
 * @param {Object} [params.dimensions={}] Optional map of dimensions for this event
 *  (e.g. 'rptKey' or 'rpeKey')
 * @returns {Object} redux action
 */
var trackButtonClick = exports.trackButtonClick = function trackButtonClick(_ref2) {
  var areaName = _ref2.areaName,
      elementPath = _ref2.elementPath,
      _ref2$dimensions = _ref2.dimensions,
      dimensions = _ref2$dimensions === undefined ? {} : _ref2$dimensions;
  return trackInteractionEvent({
    elementType: _analytics.elementList.button,
    action: _analytics.actionList.click,
    areaName: areaName,
    elementPath: elementPath,
    dimensions: dimensions
  });
};

/**
 * Convenience function for triggering link click interaction events
 *
 * @param {Object} params an object of params for the analytics event
 * @param {String} params.areaName area of app that event occurred
 * @param {Array} params.elementPath Array of strings representing path to the element in
 *  which event occurred
 * @param {Object} [params.dimensions={}] Optional map of dimensions for this event
 *  (e.g. 'rptKey' or 'rpeKey')
 * @returns {Object} redux action
 */
var trackLinkClick = exports.trackLinkClick = function trackLinkClick(_ref3) {
  var areaName = _ref3.areaName,
      elementPath = _ref3.elementPath,
      _ref3$dimensions = _ref3.dimensions,
      dimensions = _ref3$dimensions === undefined ? {} : _ref3$dimensions;
  return trackInteractionEvent({
    elementType: _analytics.elementList.link,
    action: _analytics.actionList.click,
    areaName: areaName,
    elementPath: elementPath,
    dimensions: dimensions
  });
};

/**
 * Convenience function for triggering menu item click interaction events
 *
 * @param {Object} params an object of params for the analytics event
 * @param {String} params.areaName area of app that event occurred
 * @param {Array} params.elementPath Array of strings representing path to the element
 *  in which event occurred
 * @param {Object} [params.dimensions={}] Optional map of dimensions for this event
 *  (e.g. 'rptKey' or 'rpeKey')
 * @returns {Object} redux action
 */
var trackMenuItemClick = exports.trackMenuItemClick = function trackMenuItemClick(_ref4) {
  var areaName = _ref4.areaName,
      elementPath = _ref4.elementPath,
      _ref4$dimensions = _ref4.dimensions,
      dimensions = _ref4$dimensions === undefined ? {} : _ref4$dimensions;
  return trackInteractionEvent({
    elementType: _analytics.elementList.menuItem,
    action: _analytics.actionList.click,
    areaName: areaName,
    elementPath: elementPath,
    dimensions: dimensions
  });
};


//////////////////
// WEBPACK FOOTER
// ./lib/analytics/modules/actions.js
// module id = 199
// module chunks = 0